<h2 mat-dialog-title class="subtitle-default" cdkFocusInitial>{{ _title }}</h2>

<mat-dialog-content>
  <table mat-table [dataSource]="rows" class="mat-elevation-z8">
    @for (column of columns; track column) {
      <ng-container [matColumnDef]="column">
        <th mat-header-cell *matHeaderCellDef>{{ headers[column] }}</th>
        <td mat-cell *matCellDef="let row">{{ row[column] }}</td>
      </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns"></tr>
  </table>
  <div class="col-12 text-center ver-mais-pesquisa">
    <button type="button" mat-button class="btn-primary" [disabled]="_ultimaPagina" (click)="proximaPagina()">
      @if (_isLoading === true) {
        <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
      } @else {
        <span class="material-symbols-outlined">keyboard_arrow_down</span>
        Ver mais
      }
    </button>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="action-buttons">
  <button type="button" mat-flat-button (click)="close()">Fechar</button>
</mat-dialog-actions>
